import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useId } from 'react';
import { OpenXAgentChip } from '../../shared/OpenXAgentChip';
import { OpenXAgentChipList } from '../../shared/OpenXAgentTitledCard';
import { responsiveGridSx } from '../../shared/utils/styles';
import type { OpenXAgentMatchedSegmentMetricGroup } from '../utils/types';
import { metricGroupSx } from './MatchedSegmentMetricGroups.styles';

type MatchedSegmentMetricGroupsProps = {
  groups: OpenXAgentMatchedSegmentMetricGroup[];
};

export const MatchedSegmentMetricGroups = ({ groups }: MatchedSegmentMetricGroupsProps) => {
  const idPrefix = useId();

  return (
    <Box sx={responsiveGridSx(3, 200)}>
      {groups.map(({ id, title, metrics }) => (
        <Box
          component="section"
          key={id}
          aria-labelledby={`${idPrefix}-${id}`}
          data-test={`openx-agent-matched-segment-metric-group-${id}`}
          sx={metricGroupSx}
        >
          <Typography id={`${idPrefix}-${id}`} variant="h3" noWrap sx={{ m: 0, color: 'text.primary' }}>
            {title}
          </Typography>

          <OpenXAgentChipList>
            {metrics.map(({ id: metricId, icon: Icon, label, value }) => (
              <OpenXAgentChip
                component="li"
                key={metricId}
                icon={Icon}
                data-test={`openx-agent-matched-segment-metric-${metricId}`}
              >
                {label}:{' '}
                <Box component="span" sx={{ fontWeight: 'fontWeightBold' }}>
                  {value}
                </Box>
              </OpenXAgentChip>
            ))}
          </OpenXAgentChipList>
        </Box>
      ))}
    </Box>
  );
};
